import React from "react";

const Home: React.FC = () => {
  return (
    <div className="container mx-auto p-4">
           {" "}
      <h1 className="text-4xl font-bold text-center my-8">
        Bienvenidos a Nuestros Tours
      </h1>
           {" "}
      <div className="flex justify-center">
               {" "}
        <img
          src="https://img.freepik.com/psd-gratis/explora-mundo-plantilla-publicaciones-agencias-viajes-redes-sociales_505751-5712.jpg?semt=ais_hybrid&w=740"
          alt="Tour Image"
          className="w-full max-w-md rounded-lg shadow-lg"
        />
             {" "}
      </div>
           {" "}
      <div className="my-8">
               
        https://www.youtube.com/watch?v=wSf2SOMvDD0&pp=ygURaW1hZ2VuZXMgZGUgdG91cnM%3D
             {" "}
      </div>
           {" "}
      <div className="my-8">
                https://www.google.com/maps/embed?pb=...      {" "}
      </div>
         {" "}
    </div>
  );
};

export default Home;
